// Accepts: example.com, sub-domain.example.co.uk.
// Rejects: http://example.com, example.com/path, 123.456
export function isDns(string: string) {
  const regex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\.)?$/;
  if (string.match(regex)) return true;
  return false;
}

export function isEmail(string: string) {
  const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
  if (string.match(regex)) return true;
  return false;
}

// Accepts: https://example.com/path?foo=bar, http://localhost:3000
// Rejects: example.com, ftp://example.com, ://oops
export function isUrl(string: string) {
  let url: URL;
  try {
    url = new URL(string);
  } catch { return false }

  return url.protocol === "http:" || url.protocol === "https:";
}

export function isIp(string: string) {
  const regex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;
  if (string.match(regex)) return true;
  return false;
}
